import axios from "../http";

let module = "/sysOrganization";

function selectOrganization() {
    return axios.get(module);
}

function updateOrg(data) {
    return axios.put(module, data);
}

function deleteOrg(id) {
    return axios.delete(module+"/"+id);
}

function addOrg(data) {
    return axios.post(module,data);
}

function selectOrgBingUser(id) {
    return axios.get(module+"/"+id);
}

function listUserOrgRelation(id) {
    return axios.get(module+"/listUserOrgRelation/"+id);
}
export default {
    selectOrganization,updateOrg,deleteOrg,addOrg,selectOrgBingUser,listUserOrgRelation
}
